//FAQ Search and Accordion Functionality
function initFaqSearchAccordion(section) {
  const input = section.querySelector('.faq-search-input');
  const resultsBox = section.querySelector('.faq-search-results');
  const overlay = section.querySelector('[data-faq-overlay]');
  const resultItems = section.querySelectorAll('[data-faq-result]');
  const faqItems = section.querySelectorAll('[data-faq-item]');
  const emptyState = section.querySelector('[data-faq-empty]');
  const pageNoResults = section.querySelector('[data-faq-no-results]');
  const categoryTitles = section.querySelectorAll('[data-faq-category-title]');
  const clearButton = section.querySelector('.faq-search-clear');

  if (!input || !resultsBox || !overlay) return;
//Search Layer Controls
  function openSearchLayer() {
    overlay.classList.add('active');
    resultsBox.classList.add('active');
  }

  function closeSearchLayer() {
    overlay.classList.remove('active');
    resultsBox.classList.remove('active');
  }
//Hide Empty Categories During Search
  function updateCategoryVisibility() {
    categoryTitles.forEach(function(title) {
      const category = title.id;
      const items = section.querySelectorAll('[data-category="' + category + '"]');
      let hasVisible = false;

      items.forEach(function(item) {
        if (item.style.display !== 'none') {
          hasVisible = true;
        }
      });

      title.style.display = hasVisible ? '' : 'none';
    });
  }
//Main Search function 
  function runSearch() {
    const query = input.value.toLowerCase().trim();
//iOS custom clear button visibility 
    if (clearButton) {
    clearButton.classList.toggle('active', query.length > 0);
    }

    let faqVisibleCount = 0;
    let predictiveCount = 0;
//Open predictive search layer
    if (query.length > 0) {
      openSearchLayer();
    } else {
      closeSearchLayer();
    }
//Predictive Search Results
    resultItems.forEach(function(result) {
      const text = result.dataset.search.toLowerCase();
      const matches = query.length > 0 && text.includes(query);

      result.style.display = matches ? 'block' : 'none';

      if (matches) predictiveCount++;
    });
    //add in remove border from last visible item in results
    resultItems.forEach(function(result) {
    result.classList.remove('is-last-visible');
    });

    const visibleResults = Array.from(resultItems).filter(function(result) {
    return result.style.display !== 'none';
    });
// Add class to final visible predictive result 
    if (visibleResults.length > 0) {
    visibleResults[visibleResults.length - 1].classList.add('is-last-visible');
    }

//FAQ Accordion Filtering
    faqItems.forEach(function(faq) {
      const text = faq.dataset.search.toLowerCase();
      const matches = query.length === 0 || text.includes(query);

      faq.style.display = matches ? '' : 'none';

      if (matches) faqVisibleCount++;
    });
    //Empty States
// Predictive search no-results state
    if (emptyState) {
      emptyState.hidden = !(query.length > 0 && predictiveCount === 0);
    }
 // Full FAQ no-results state
    if (pageNoResults) {
      pageNoResults.hidden = faqVisibleCount > 0;
    }

    updateCategoryVisibility();
  }
//Search Events
  input.addEventListener('focus', function() {
    if (input.value.trim().length > 0) {
      openSearchLayer();
    }
  });

  input.addEventListener('input', runSearch);

//iOS custom clear search button
  if (clearButton) {
  clearButton.addEventListener('click', function() {
    input.value = '';
    runSearch();
    input.focus();
  });
}
//Close predictive layer when clicking overlay
  overlay.addEventListener('click', closeSearchLayer);
// Predictive Search Result Click
  resultItems.forEach(function(result) {
    result.addEventListener('click', function() {
      const targetId = result.dataset.target;
      const target = document.getElementById(targetId);

      if (!target) return;

      closeSearchLayer();
// Reset hidden FAQ items after search
      faqItems.forEach(function(faq) {
        faq.style.display = '';
      });

      updateCategoryVisibility();

      target.open = true;

      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  });
//Manual Category Navigation Click
  section.querySelectorAll('.category_menu-item').forEach(function(link) {
    link.addEventListener('click', function() {
      section.querySelectorAll('.category_menu-item').forEach(function(item) {
        item.classList.remove('category_menu-active');
      });

      link.classList.add('category_menu-active');
    });
  });
  section.querySelectorAll('.category_menu-item').forEach(function(link) {
    link.addEventListener('click', function() {
      section.querySelectorAll('.category_menu-item').forEach(function(item) {
        item.classList.remove('category_menu-active');
      });

      link.classList.add('category_menu-active');
    });
  });

// Close other accordion items when one is opened
const accordionItems = section.querySelectorAll('.faq-item');
accordionItems.forEach(function(item) {
  item.addEventListener('toggle', function() {
    if (!item.open) return;
    // Close other accordion items first
    accordionItems.forEach(function(otherItem) {
      if (otherItem !== item) {
        otherItem.open = false;
      }
    });
    // Update active category state
    const categoryId = item.dataset.category;

    section.querySelectorAll('.category_menu-item').forEach(function(link) {
      link.classList.remove('category_menu-active');
    });

    const matchingLink = section.querySelector(
      '.category_menu-item[href="#' + categoryId + '"]'
    );

    if (matchingLink) {
      matchingLink.classList.add('category_menu-active');
    }

    // Prevent scroll jumping after long accordion collapses
    window.requestAnimationFrame(function() {
      item.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  });
});

// Active category on scroll
const categoryHeaders = section.querySelectorAll('.faq-category-title');
const categoryLinks = section.querySelectorAll('.category_menu-item');

function updateActiveCategoryOnScroll() {
  let currentCategory = '';

  categoryHeaders.forEach(function(header) {
    const rect = header.getBoundingClientRect();

    if (rect.top <= 140) {
      currentCategory = header.id;
    }
  });

  categoryLinks.forEach(function(link) {
    link.classList.remove('category_menu-active');

    const href = link.getAttribute('href');

    if (href === '#' + currentCategory) {
      link.classList.add('category_menu-active');
    }
  });
}

window.addEventListener('scroll', updateActiveCategoryOnScroll);

updateActiveCategoryOnScroll();
}
//Initialize FAQ Sections
function initAllFaqSearchAccordions() {
  document.querySelectorAll('.faq-search-section').forEach(function(section) {
    if (section.dataset.faqInitialized === 'true') return;

    section.dataset.faqInitialized = 'true';

    initFaqSearchAccordion(section);
  });
}
//clear search x only on ios (webkit not supported)
// Detect iOS devices
if (
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
) {
  document.documentElement.classList.add('ios-device');
}
//Initial Page Load
document.addEventListener('DOMContentLoaded', initAllFaqSearchAccordions);
//Shopify Theme Editor Reload
document.addEventListener('shopify:section:load', function(event) {
  const section = event.target.querySelector('.faq-search-section');

  if (section) {
    section.dataset.faqInitialized = 'false';
    initFaqSearchAccordion(section);
  }
});
//ESC Key Close Search Overlay
document.addEventListener('keydown', function(event) {
  if (event.key !== 'Escape') return;

  document.querySelectorAll('.faq-search-section').forEach(function(section) {
    const overlay = section.querySelector('[data-faq-overlay]');
    const resultsBox = section.querySelector('.faq-search-results');

    if (overlay) overlay.classList.remove('active');
    if (resultsBox) resultsBox.classList.remove('active');
  });
});